import { createSelector } from 'reselect';

import type { RootState } from 'config/store/reducers';

const getState = (state: RootState) => state.works;

export const getData = createSelector(getState, (works) => works.data);
export const getUI = createSelector(getState, (works) => works.ui);

export const getSelectedChecklistGroupId = createSelector(getUI, (ui) => ui.selectedGroupOffer || undefined); // returns undefined because API doesn't support null
